module.exports = ".shopitem-badges {\n  position: absolute;\n  bottom: 1rem;\n  width: 100%; }\n\n.sale .price {\n  text-decoration: line-through; }\n\n.sale .badge-sale, .sale .price-sale {\n  display: inline-block; }\n\n.sold .price, .sold .price-sale {\n  text-decoration: line-through; }\n\n.sold .badge-sold {\n  display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Styles/product.summary.scss
// module id = ./src/app/Styles/product.summary.scss
// module chunks = main